import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { useDialpadManagerClient } from '@frontend/dialpad';
import { ActionBarBoundary } from '@frontend/error-boundary';
import { useHasPhoneSystemAccess } from '@frontend/phone-config';
import { useWindowWidth } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { DialpadWrap } from '../../../dialpad-wrap';
import { SoftphoneWrap } from '../../../softphone-wrap';

export const Dialpad = () => {
  const isSoftphoneDeviceConnected = useDialpadManagerClient((ctx) => ctx?.isSoftphoneDeviceConnected);

  const windowWidth = useWindowWidth({ tolerance: 5 });
  const allowSoftphoneTrayViewInTopBar = windowWidth > 850;
  if (isSoftphoneDeviceConnected) {
    return (
      <SoftphoneWrap
        allowTrayView={allowSoftphoneTrayViewInTopBar}
        allowButtonView={true}
        allowPopout={allowSoftphoneTrayViewInTopBar}
      />
    );
  }
  return <DialpadWrap />;
};

export const DialpadWrapper = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const hasPhoneSystemAccess = useHasPhoneSystemAccess({ locationIds: selectedLocationIds });

  return <SentryErrorBoundary fallback={ActionBarBoundary}>{hasPhoneSystemAccess && <Dialpad />}</SentryErrorBoundary>;
};
